
import Style from "../../VideoGallery.module.scss";
import Icons from "../../../Layouts/Icons";
import { useDimensions } from "../../../../Logic/Dimensions";
import { useVideos } from "../../useVideos";

export const SelectBtn = ({ handlePreSelect }) => {
    const windowDimensions = useDimensions();
    const { resultData } = useVideos()

    return (
        <button
            className={`a-05 ${Style.dashboard_btn} ${"btn btn-border-grey"}`}
            type="button"
            onClick={() => handlePreSelect()}
            disabled={resultData?.data?.length == 0}
        >
            <Icons color={'currentColor'} icon={"icon-square"} size={14} />
            {windowDimensions.width >= 1200 && ('Select')}
        </button>
    );
};